export default __webpack_public_path__ + "static/media/FaqBanner.2364a6da.jpeg";